export default __webpack_public_path__ + "static/media/docvault.45bbb41b.png";